import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import IntroductionRoutes from "./pages/Introduction";

const MainRoutes = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<App />} />
        {/* <Route
          path="introduction/:productName"
          element={<IntroductionRoutes />}
        /> */}
      </Routes>
    </BrowserRouter>
  );
};

export default MainRoutes;
